import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-view',
  templateUrl: './toggle-view.component.html',
  styleUrls: ['./toggle-view.component.css']
})
export class ToggleViewComponent implements OnInit {

  @Output() changeView = new EventEmitter<boolean>();

  toggle: boolean = true;

  constructor() { }

  ngOnInit(): void { }

  /**
   * Determines whether click on
   */
  onClick() {
    this.toggle = !this.toggle;
    this.changeView.emit(this.toggle);
  }
}
